import React from 'react';
import AccessTitle from './AccessTitle';
import AccessGrid from './AccessGrid';
import { useStyles } from './KantoAccess';

const KansaiAccess = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AccessTitle type="train" />
      <div className={classes.wrapper}>
        <AccessGrid
          directions={[
            '新大阪駅',
            'JR新幹線のぞみ\n（約50分）',
            '名古屋駅',
            'JR特急ワイドビューひだ\n（約2時間25分）',
            '高山駅',
            'JR高山本線\n（約15分）',
            '飛騨古川駅',
          ]}
        />
      </div>
      <div className={classes.line} />
      <AccessTitle type="bus" />
      <div className={classes.wrapper}>
        <AccessGrid
          directions={[
            [
              <span key="osaka">大阪</span>,
              <span key="higashi-umeda">東梅田</span>,
            ],
            '濃飛バス・近鉄バス\n（約5時間10分）',
            [
              <span key="takayama">高山</span>,
              <span key="bus-center">バスセンター</span>,
            ],
            '濃飛バス\n（約35分）',
            '古川駅前',
          ]}
        />
      </div>
      <div className={classes.line} />
      <AccessTitle type="car" />
      <div className={classes.wrapper}>
        <AccessGrid
          directions={[
            '吹田IC',
            '名神高速道路\n（約1時間50分）',
            '一宮JCT',
            '東海北陸自動車道\n（約1時間40分）',
            [<span key="hida-kiyomi">飛騨清見</span>, <span key="ic">IC</span>],
            '県道90号線（飛騨卯の花街道）（約30分）',
            '飛騨古川',
          ]}
        />
      </div>
    </div>
  );
};

export default KansaiAccess;
